import * as core from '../../../../../../../core'
import * as attainSpecKit from '../attain-spec-kit'

export const RESOURCE = {
  payload: {
    alias: 'design',
    appAlias: attainSpecKit.RESOURCE.payload.alias,
    description: 'Browse specs and their approval state',
    display: {
      isMain: true,
      position: 2,
    },
    name: 'Design',
    page: { alias: 'design' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
